<template>
    <DashboardContainer v-if="loaded"/>
</template>

<script>
import { ref } from '@vue/composition-api'
import DashboardContainer from '@/modules/Dashboard'
import store from '@/store'
import DashboardStore from '@/modules/Dashboard/_store'
import useSelectProjectAndGroup from '@/composables/useSelectProjectAndGroup'
export default {
    components: {
        DashboardContainer
    },
    setup () {
        const {
            selectedGroup,
            selectedProject,
            setInitialAccountSelect
        } = useSelectProjectAndGroup()
        if (!selectedProject.value?.projectIdx && !selectedGroup.value?.groupIdx) {
            setInitialAccountSelect(true)
        }
        const loaded = ref(false)
        store.dispatch('$_dashboard/getCustomDashboard', { userIdx: store.getters.authUserInfo.userIdx }).then(() => {
            loaded.value = true
        })
        return {
            loaded
        }
    },
    beforeRouteEnter (to, from, next) {
        const STORE_KEY = '$_dashboard'
        if (!(STORE_KEY in store._modules.root._children)) {
            store.registerModule(STORE_KEY, DashboardStore)
        }
        next()
    }
}
</script>

<style>

</style>
